import { useEffect, useState } from "react";
import { DownloadSimple, Table as TableIcon } from "@phosphor-icons/react";
import { api, API } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { money } from "@/lib/api";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

const MONEY_COLS = ["Amount", "Total Funding", "Allocated", "Remaining", "Amount Requested"];

export default function Reports() {
  const [catalog, setCatalog] = useState([]);
  const [active, setActive] = useState(null);
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get("/reports/catalog").then((r) => {
      setCatalog(r.data);
      if (r.data[0]) select(r.data[0].key);
    });
    // eslint-disable-next-line
  }, []);

  const select = async (key) => {
    setActive(key);
    const { data } = await api.get(`/reports/${key}`);
    setReport(data);
  };

  const exportCsv = () => window.open(`${API}/reports/${active}/export`, "_blank");

  return (
    <div>
      <PageHeader
        overline="Reporting Center"
        title="Reports"
        actions={report && report.rows.length > 0 && (
          <Button data-testid="export-csv" variant="outline" onClick={exportCsv}><DownloadSimple size={16} className="mr-1.5" /> Export CSV</Button>
        )}
      >
        Export-ready operational and leadership views across contracts and grants.
      </PageHeader>

      <div className="flex flex-wrap gap-2 mb-6">
        {catalog.map((r) => (
          <button
            key={r.key}
            data-testid={`report-${r.key}`}
            onClick={() => select(r.key)}
            className={`px-3.5 py-2 rounded-md border text-sm transition-colors ${active === r.key ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border hover:border-primary"}`}
          >
            {r.name}
          </button>
        ))}
      </div>

      {report && (
        <div className="bg-card border border-border rounded-md overflow-hidden">
          <div className="px-5 py-3 border-b border-border flex items-center gap-2 text-sm text-muted-foreground">
            <TableIcon size={16} /> {report.name} · {report.rows.length} row(s)
          </div>
          {report.rows.length === 0 ? (
            <div className="px-5 py-10 text-center text-sm text-muted-foreground">No data for this report.</div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>{report.columns.map((col) => <TableHead key={col}>{col}</TableHead>)}</TableRow>
                </TableHeader>
                <TableBody>
                  {report.rows.map((row, i) => (
                    <TableRow key={i} data-testid={`report-row-${i}`}>
                      {report.columns.map((col) => (
                        <TableCell key={col} className="text-sm">
                          {MONEY_COLS.includes(col) && typeof row[col] === "number" ? money(row[col]) : String(row[col] ?? "—")}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
